import { defineMessages } from 'react-intl';

export const messages: {
	suggested_filter: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	apply_suggested_filter: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	suggested_filter_icon_label: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	project: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	assignee: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	app: {
		id: string;
		defaultMessage: string;
		description: string;
	};
} = defineMessages({
	suggested_filter: {
		id: 'searchDialog.suggested.filter',
		defaultMessage: 'Suggested filter',
		description:
			'Text shown as a tag on a suggested filter chip in the Quick Find search dialog, indicating to users that the filter has been automatically recommended.',
	},
	apply_suggested_filter: {
		id: 'searchDialog.apply.suggested.filter',
		defaultMessage: 'Apply filter',
		description:
			'Text shown on a button that appears when a user hovers over a suggested filter chip in the Quick Find dialog, allowing them to apply the suggested filter.',
	},
	suggested_filter_icon_label: {
		id: 'searchDialog.suggestedFilter.icon.label',
		defaultMessage: 'Suggestion search',
		description: 'Assistive label for Suggestion search queries',
	},
	// filter name messages
	project: {
		id: 'searchDialog.suggestedFilter.filterName.project',
		defaultMessage: 'project',
		description:
			'The word used to name the project filter in a suggested filter chip within the Quick Find dialog (e.g. "Filter by project").',
	},
	assignee: {
		id: 'searchDialog.suggestedFilter.filterName.assignee',
		defaultMessage: 'assignee',
		description:
			'The word used to name the assignee filter in a suggested filter chip within the Quick Find dialog (e.g. "Filter by assignee").',
	},
	app: {
		id: 'searchDialog.suggestedFilter.filterName.product',
		defaultMessage: 'app',
		description:
			'The word used to name the app/product filter in a suggested filter chip within the Quick Find dialog (e.g. "Filter by app").',
	},
});
